import clsx from "clsx"

import styles from "./SelectListHeader.module.scss"
import { SelectListHeaderProps } from "./SelectListHeader.types"

export default function SelectListHeader(props: SelectListHeaderProps) {
    const { children, className } = props

    return <div className={clsx(styles.base, className)}>{children}</div>
}
